import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  TextInput, required, BooleanInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  FormDataConsumer,
} from "react-admin";
import EditView from "../../../components/EditView";
import CreateView from "../../../components/CreateView";
import ShowView from "../../../components/ShowView";

export const UnitList = (props) => (

  <List {...props}  perPage={100}>
    <Datagrid rowClick="edit"  sort={{ field: 'order', order: 'ASC' }}>
      {/* <DateField  locales={"fa-IR"} source="createdAt" /> */}
      <TextField source="title" />
      <TextField source="order" />
    </Datagrid>
  </List>
);

export const UnitEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="order" validate={required()} />
    <TextInput source="title" validate={required()} />
    <BooleanInput source="hideInreport"/>
    <BooleanInput source="allProductAvailable"/>
    <FormDataConsumer>
      {({ formData, ...rest }) => !formData.allProductAvailable && <div>

        <ReferenceArrayInput source="users" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput variant="outlined" source="name" optionText="name" />
        </ReferenceArrayInput >
      </div>
      }
    </FormDataConsumer>
  </EditView>
);

export const UnitShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="order" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" />
    </SimpleShowLayout>
  </ShowView>
);

export const UnitCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="order" label="ترتیب" />
    <TextInput source="title" label="عنوان" />
  </CreateView>
);
